import { render, staticRenderFns } from "./customerForm.vue?vue&type=template&id=fc0f8b08"
import script from "./customerForm.vue?vue&type=script&lang=js"
export * from "./customerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports